import * as Select from '@radix-ui/react-select';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/chords/Icon';

import { DROPDOWN_CLEAR_SENTINEL_VALUE } from '../constants';
import { DROPDOWN_OPTION_CLEAR_CLASS } from '../styles';

export function DropdownItemClear() {
  const { t } = useTranslation('common');

  return (
    <div className="border-b border-emphasis-subtle">
      <Select.Item
        value={DROPDOWN_CLEAR_SENTINEL_VALUE}
        className={DROPDOWN_OPTION_CLEAR_CLASS}
      >
        <Select.ItemText>
          <Trans
            i18nKey="dropdownTree.clearSelectionWithIcon"
            t={t}
            components={{
              Icon: (
                <span className="mr-sm">
                  <Icon type="xmark" size="sm" aria-hidden />
                </span>
              ),
            }}
          />
        </Select.ItemText>
      </Select.Item>
    </div>
  );
}

DropdownItemClear.displayName = 'DropdownItemClear';
